// extracted by mini-css-extract-plugin
export default {"tooltip":"go-z","sharingV2":"ho-z","sharingIconsV2":"io-z","links":"jo-z","link":"ko-z","facebookV2":"lo-z","twitterV2":"mo-z","pinterestV2":"no-z"};